<script>
const ROWS_PER_PAGE = 10;
const PAGINATION_RANGE = 2;

export default {
  props: {
    pagination: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      pages: []
    };
  },

  methods: {
    navigate(page) {
      if (page == "..." || page == 0 || page == this.pagination.totalPages + 1)
        return;
      this.$emit("changePage", page);
    },

    generatePagesArray: function(
      currentPage,
      collectionLength,
      rowsPerPage,
      paginationRange
    ) {
      var pages = [];
      var totalPages = Math.ceil(collectionLength / rowsPerPage);
      var halfWay = Math.ceil(paginationRange / 2);
      var position;

      if (currentPage <= halfWay) {
        position = "start";
      } else if (totalPages - halfWay < currentPage) {
        position = "end";
      } else {
        position = "middle";
      }

      var ellipsesNeeded = paginationRange < totalPages;
      var i = 1;
      while (i <= totalPages && i <= paginationRange) {
        var pageNumber = this.calculatePageNumber(
          i,
          currentPage,
          paginationRange,
          totalPages
        );
        var openingEllipsesNeeded =
          i === 2 && (position === "middle" || position === "end");
        var closingEllipsesNeeded =
          i === paginationRange - 1 &&
          (position === "middle" || position === "start");
        if (
          ellipsesNeeded &&
          (openingEllipsesNeeded || closingEllipsesNeeded)
        ) {
          pages.push("...");
        } else {
          pages.push(pageNumber);
        }
        i++;
      }
      return pages;
    },

    calculatePageNumber: function(i, currentPage, paginationRange, totalPages) {
      var halfWay = Math.ceil(paginationRange / 2);
      if (i === paginationRange) {
        return totalPages;
      } else if (i === 1) {
        return i;
      } else if (paginationRange < totalPages) {
        if (totalPages - halfWay < currentPage) {
          return totalPages - paginationRange + i;
        } else if (halfWay < currentPage) {
          return currentPage - halfWay + i;
        } else {
          return i;
        }
      } else {
        return i;
      }
    }
  },

  mounted() {
    this.pages = this.generatePagesArray(
      this.pagination.current,
      this.pagination.totalResults,
      ROWS_PER_PAGE,
      PAGINATION_RANGE
    );
  },

  watch: {
    "pagination.current": function() {
      this.pages = this.generatePagesArray(
        this.pagination.current,
        this.pagination.totalResults,
        ROWS_PER_PAGE,
        PAGINATION_RANGE
      );
    },

    "pagination.totalResults": function() {
      this.pages = this.generatePagesArray(
        this.pagination.current,
        this.pagination.totalResults,
        ROWS_PER_PAGE,
        PAGINATION_RANGE
      );
    }
  }
};
</script>

<template>
  <ul v-if="pagination.totalPages > 1">
    <li
      :class="{ disabled: pagination.current == 1 }"
      @click.prevent="navigate(pagination.current - 1)"
    >
      anterior
    </li>
    <li
      v-for="(page, index) in pages"
      :key="index"
      :class="{ active: page == pagination.current }"
      class="item"
      @click.prevent="navigate(page)"
    >
      {{ page }}
    </li>
    <li
      :class="{ disabled: pagination.current == pagination.totalPages }"
      @click.prevent="navigate(pagination.current + 1)"
    >
      próximo
    </li>
  </ul>
</template>

<style scoped>
ul {
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: none;
  list-style: none;
}

ul li {
  min-width: 38px;
  min-height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-left: none;
  user-select: none;
  cursor: pointer;
  font-size: 14px;
  border-radius: 4px;
  margin: 0 2px;
  transition: all 0.24s ease;
}

ul li:hover {
  background-color: #eee;
}

ul li:first-child,
ul li:last-child {
  padding: 0 10px;
  width: auto;
  height: 38px;
}

ul li.disabled {
  color: #999;
  background-color: transparent !important;
}

ul li.active {
  color: #fff;
  background: var(--purple);
}

@media (max-width: 768px) {
  ul li.item {
    display: none;
  }

  ul li.item.active {
    display: inherit;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Pagination.vue